<template>
  <reusable-dialog v-model="isVisibleDialog">
    <h3
      slot="title"
      v-text="$t('payment.auto.redirection.confirm.title')"
    ></h3>

    <div :class="$style.content">
      <p v-html="displayMessage"></p>
    </div>

    <simple-button
      slot="submit"
      variant="primary"
      @click="handleSubmit"
    >
      {{ $t('payment.auto.redirection.confirm.submit') }}
    </simple-button>

    <simple-button
      slot="cancel"
      variant="transparent"
      @click="isVisibleDialog = false"
    >
      {{ $t('common.cancel') }}
    </simple-button>
  </reusable-dialog>
</template>

<script>
import SimpleButton from 'molecules/common/SimpleButton';

import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'PaymentAutoRedirectionConfirm',
  components: {
    SimpleButton,
  },
  created() {
    EVENT_BUS.$on('EVENT_CONFIRM_TO_PAYMENT_AUTO_REDIRECTION', this.initialize);
  },
  beforeDestroy() {
    EVENT_BUS.$off('EVENT_CONFIRM_TO_PAYMENT_AUTO_REDIRECTION', this.initialize);
  },
  data() {
    return {
      isVisibleDialog: false,
    };
  },
  computed: {
    displayMessage() {
      return this.$t('payment.auto.redirection.confirm.message', {
        link: '/payment/settings/technical',
      });
    },
  },
  methods: {
    initialize() {
      this.isVisibleDialog = true;
    },
    handleSubmit() {
      this.$emit('confirm');
      this.isVisibleDialog = false;
    },
  },
};
</script>

<style lang="sass" module>
  .content
    color: #fff
    opacity: .75

    a
      color: var(--color-green)
      text-decoration: underline
</style>
